/* CozySpun Home: delivery estimate (US) + holiday cutoff. Business days skip Sat/Sun. */
(function () {
  if (window.customElements && customElements.get('cs-delivery-estimate')) return;
  var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var DAYS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  function today() {
    try {
      var m = /[?&]cs_today=(\d{4})-(\d{2})-(\d{2})/.exec(window.location.search);
      if (m) return new Date(+m[1], +m[2] - 1, +m[3]);
    } catch (e) {}
    var n = new Date();
    return new Date(n.getFullYear(), n.getMonth(), n.getDate());
  }
  function isBiz(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function addBiz(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() + 1); if (isBiz(r)) n--; }
    return r;
  }
  function subBiz(d, n) {
    var r = new Date(d.getTime());
    while (n > 0) { r.setDate(r.getDate() - 1); if (isBiz(r)) n--; }
    return r;
  }
  function fmt(d) { return MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  // Christmas cutoff: deliver by Dec 24 using max 15 business days (3 processing + 12 transit) + 2 business days buffer.
  function christmasCutoff(year) { return subBiz(new Date(year, 11, 24), 15 + 2); }
  window.CozySpunDelivery = { addBiz: addBiz, christmasCutoff: christmasCutoff, today: today };

  class Estimate extends HTMLElement {
    connectedCallback() { render(this); }
  }
  function render(el) {
    var t = today();
    var min = parseInt(el.getAttribute('data-min') || '9', 10);
    var max = parseInt(el.getAttribute('data-max') || '15', 10);
    var main = el.querySelector('[data-cs-text]');
    if (main) {
      main.textContent = 'Order today, estimated US delivery ' + fmt(addBiz(t, min)) + ' \u2013 ' + fmt(addBiz(t, max));
    }
    var hol = el.querySelector('[data-cs-holiday]');
    if (hol) {
      var cutoff = christmasCutoff(t.getFullYear());
      var start = new Date(t.getFullYear(), 9, 1);
      if (t >= start && t <= cutoff) {
        hol.textContent = 'Order by ' + DAYS[cutoff.getDay()] + ', ' + fmt(cutoff) + ' for Christmas delivery (US)';
        hol.hidden = false;
      } else {
        hol.hidden = true;
      }
    }
  }
  customElements.define('cs-delivery-estimate', Estimate);
})();
